import { Flex } from '@mantine/core';
import { KYCWorkflowFileItemRes } from '@dealstack/shared/lib/generated/models/KYCWorkflowFileItemRes';
import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns.tsx';
import { ExpandedListContainer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/components/ExpandedListContainer.tsx';
import { StatusTooltipCount } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/components/StatusTooltipCount.tsx';
import { TextStatusRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/components/TextStatusRow.tsx';
import { EXPECTED_STATUS } from '@dealstack/shared/lib/common/business/kyc';
import { KYCDocumentStatus, getFileDisplayStatus, groupFilesByDisplayStatus } from './utils.ts';

interface Props {
	files: KYCWorkflowFileItemRes[];
	overallStatus: KYCDocumentStatus | null;
	isExpanded: boolean;
	fallbackName: string;
}

export const DocumentStatusCell = ({ files, overallStatus, isExpanded, fallbackName }: Props) => {
	if (overallStatus === null) {
		return <>{LONG_DASH}</>;
	}

	if (isExpanded) {
		if (files.length) {
			return (
				<ExpandedListContainer>
					{files.map((f) => (
						<TextStatusRow
							key={f.id}
							name={f.fileName}
							status={getFileDisplayStatus(f)}
							isInherited={f.isInherited}
							isKyc
						/>
					))}
				</ExpandedListContainer>
			);
		}
		return (
			<ExpandedListContainer>
				<TextStatusRow name={fallbackName} status={EXPECTED_STATUS} isKyc />
			</ExpandedListContainer>
		);
	}

	const displayItems: KYCWorkflowFileItemRes[] = files.length
		? files
		: [
				{
					id: 'expected',
					fileName: fallbackName,
					status: null,
					isInherited: false,
					isAwaitingCertifier: false,
				},
			];

	return (
		<Flex gap="0.5rem" wrap="wrap">
			{groupFilesByDisplayStatus(displayItems).map((group) => (
				<StatusTooltipCount
					key={group.status}
					status={group.status}
					items={group.items}
					isKyc
				/>
			))}
		</Flex>
	);
};
